import React from "react";
import { motion } from "framer-motion";
import { fadeIn, staggerContainer } from "../variants";
import { partenerData } from "../data";
import { ExternalLink } from "lucide-react";

const Partners = () => {
  return (
    <section id="partners" className="section scroll-mt-20 bg-light">
      <div className="container mx-auto">

        {/* Header */}
        <motion.div
          variants={staggerContainer(0.12, 0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="section-header"
        >
          <motion.p variants={fadeIn("up")} className="eyebrow mb-4">
            Ils nous soutiennent
          </motion.p>
          <motion.h2 variants={fadeIn("up", 0.05)} className="h2 mb-6">
            Nos partenaires institutionnels
          </motion.h2>
          <motion.p variants={fadeIn("up", 0.1)} className="lead">
            Depuis 2004, des organisations publiques et privées en France et au Tchad nous font
            confiance pour mener à bien nos projets éducatifs.
          </motion.p>
        </motion.div>

        {/* Partners grid */}
        <motion.div
          variants={staggerContainer(0.08, 0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-16"
        >
          {partenerData.map((partner, i) => (
            <motion.a
              key={i}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              variants={fadeIn("up", i * 0.05)}
              className="group card p-6 flex flex-col items-center justify-center text-center hover:border-primary/20 border border-transparent transition-all duration-300 min-h-[140px]"
            >
              <div className="relative w-full h-16 flex items-center justify-center mb-4">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-14 max-w-full object-contain opacity-70 group-hover:opacity-100 transition-all duration-300 grayscale group-hover:grayscale-0"
                />
              </div>
              <div className="text-xs text-grey group-hover:text-dark transition-colors duration-200 leading-snug font-medium">
                {partner.name}
              </div>
              <ExternalLink
                size={12}
                className="text-primary opacity-0 group-hover:opacity-100 transition-all duration-300 mt-2 flex-shrink-0"
              />
            </motion.a>
          ))}
        </motion.div>

        {/* Become partner CTA */}
        <motion.div
          variants={fadeIn("up")}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="bg-gradient-to-r from-primary to-primary-light text-white rounded-2xl p-8 lg:p-12 text-center relative overflow-hidden"
        >
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-1/4 w-64 h-64 rounded-full bg-white" style={{ transform: "translateY(-50%)" }} />
            <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full bg-secondary" style={{ transform: "translateY(50%)" }} />
          </div>
          <div className="relative">
            <h3 className="font-heading font-bold text-2xl lg:text-3xl mb-4">
              Devenir partenaire de l'APPE
            </h3>
            <p className="text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
              Vous souhaitez soutenir notre mission en tant qu'entreprise, fondation ou institution ?
              Nous serions ravis d'explorer ensemble les possibilités de partenariat.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-white text-primary font-semibold px-8 py-3.5 rounded-full hover:bg-white/90 transition-colors shadow-lg"
            >
              Nous contacter
            </a>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Partners;
